import { Component } from '@angular/core';
import { UsuarioAPIService } from '../../services/usuario-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuarioCriarSenha } from 'src/app/shared/interfaces/usuario/usuario-criar-senha.interface';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-criar-senha-login',
  templateUrl: './criar-senha-login.component.html',
  styleUrl: './criar-senha-login.component.scss'
})
export class CriarSenhaLoginComponent {
  public usuarioLogin: string = "";
  public usuario: UsuarioCriarSenha = { senha: null, confirmarSenha: null, token: null };
  public senhaValida: boolean = false;
  public senhasIguais: boolean = false;
  public mensagemErro: string = "";
  public isLoading: boolean = false;
  public block: boolean = false;

  // Critérios de validação da senha
  public criterios = {
    minimo10Caracteres: false,
    temMaiuscula: false,
    temCaractereEspecial: false,
    temNumero: false,
    temLetra: false
  };

  constructor(private usuarioAPIService: UsuarioAPIService, 
              private route: ActivatedRoute,
              private router: Router,
              private toast: ToastrService){ }

  ngOnInit() {
    let token = this.route.snapshot.paramMap.get('token');
    if (!!token) {
      this.usuario.token = token;
      this.usuarioAPIService.getByToken(token).subscribe(async (res) => {
        if (res) {
          // Token válido - usuário pode criar senha
          console.log('Token válido');
        } else {
          // Token inválido - redirecionar ou mostrar erro
          this.toast.warning("Atenção", "Token inválido ou expirado.");
          this.block = true;
        }       
      }, error => {
        this.toast.error("Error", "Erro ao validar o Token");
        this.block = true;
      });
    } else {
      this.toast.error("Erro", "Token não encontrado.");
      this.block = true;
    }
  }

 // Validar senha em tempo real
  onSenhaChange() {
    this.validarSenha();
    this.verificarSenhasIguais();
  }

  // Validar confirmação de senha
  onConfirmarSenhaChange() {
    this.verificarSenhasIguais();
  }

  private validarSenha() {
    const senha = this.usuario.senha || '';
    
    // Critério 1: Mínimo 10 caracteres
    this.criterios.minimo10Caracteres = senha.length >= 10;
    
    // Critério 2: Pelo menos uma letra maiúscula
    this.criterios.temMaiuscula = /[A-Z]/.test(senha);
    
    // Critério 3: Pelo menos um caractere especial
    this.criterios.temCaractereEspecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(senha);
    
    // Critério 4: Pelo menos um número (alfanumérica)
    this.criterios.temNumero = /[0-9]/.test(senha);
    
    // Critério 5: Pelo menos uma letra
    this.criterios.temLetra = /[a-zA-Z]/.test(senha);
    
    // Senha é válida se todos os critérios forem atendidos
    this.senhaValida = this.criterios.minimo10Caracteres && 
                      this.criterios.temMaiuscula && 
                      this.criterios.temCaractereEspecial && 
                      this.criterios.temNumero && 
                      this.criterios.temLetra;
  }

  private verificarSenhasIguais() {
    this.senhasIguais = this.usuario.senha === this.usuario.confirmarSenha && 
                        !!this.usuario.senha && 
                        !!this.usuario.confirmarSenha;
  }

  // Verificar se pode criar a senha
  podeCrearSenha(): boolean {
    return this.senhaValida && this.senhasIguais && !this.isLoading;
  }

  criarSenha() {
    this.mensagemErro = "";
    
    if (!this.senhaValida) {
      this.mensagemErro = "A senha não atende aos critérios de segurança.";
      return;
    }

    if (!this.senhasIguais) {
      this.mensagemErro = "As senhas não coincidem.";
      return;
    }

    this.isLoading = true;

    // Chamar o serviço para criar a senha
    this.usuarioAPIService.resetarSenha(this.usuario).subscribe(
      (response) => {
        this.isLoading = false;
        this.toast.success("Sucesso", "Senha criada com sucesso!.");
        this.router.navigate(['/autenticacao/login']);
      },
      (error) => {
        this.isLoading = false;
        this.mensagemErro = "Erro ao criar senha. Tente novamente.";
        console.error('Erro ao criar senha:', error);
      }
    );
  }
}
